import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IManualBatchLiberacao } from '../../../models/manual-batch';

export interface LiberarManualDialogData {
  batchId: string;
}

@Component({
  selector: 'app-liberar-manual-dialog',
  templateUrl: './liberar-manual-dialog.component.html',
  styleUrls: ['./liberar-manual-dialog.component.scss']
})
export class LiberarManualDialogComponent {
  form: FormGroup;
  submitting = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LiberarManualDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LiberarManualDialogData
  ) {
    this.form = this.fb.group({
      paymentDate: ['', Validators.required],
      orderNumber: ['', Validators.required],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSubmit(): void {
    if (this.form.valid && !this.submitting) {
      this.submitting = true;
      
      const dialogPayload: IManualBatchLiberacao = {
        BatchId: this.data.batchId,
        PaymentDate: this.form.value.paymentDate,
        OrderNumber: this.form.value.orderNumber
      };

      this.dialogRef.close({ payload: dialogPayload });
      
    }
  }
}
